import _indexOf from "lodash/indexOf";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import ReactModal from "react-modal";
import "./index.scss";
import { assert } from "@/common/assert";
import { assertNever, formatImageUrl } from "@/common/utils";
import { convertTextToEmojiHtml } from "@/common/emojis";
import { wait } from "@/pages/base/asyncUtils";
import { CompactMessageTypeEnum } from "@/apis/model/CompactMessageTypeEnum";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
export function CompactCompositeMessageItemWrapper(props) {
  var item = props.item;
  var inner;
  var info;

  switch (item.Type) {
    case CompactMessageTypeEnum.Text:
      var html = convertTextToEmojiHtml(item.Text.Text);
      var r = html.replace(/\r\n|\r|\n/g, "<br />");
      inner = _jsx("p", {
        children: html
      }, void 0);
      info = item.Text.Info;
      inner = _jsx("p", {
        dangerouslySetInnerHTML: {
          __html: r
        }
      }, void 0);
      break;

    case CompactMessageTypeEnum.Image:
      inner = _jsx("img", {
        className: "chat-record__img",
        src: formatImageUrl(item.Image.ImageUrl, ImageSizeTypeEnum.Thumbnail200whFill)
      }, void 0);
      info = item.Image.Info;
      break;

    case CompactMessageTypeEnum.Other:
      inner = _jsx("p", {
        children: item.Other.Text
      }, void 0);
      info = item.Other.Info;
      break;

    case CompactMessageTypeEnum.Compact:
      info = item.Composite.Info;
      inner = _jsxs("ul", {
        children: [_jsx("span", __assign({
          className: "chat-record__record-mark"
        }, {
          children: "[" + info.UserName + "\u7684\u804A\u5929\u8BB0\u5F55]"
        }), void 0), item.Composite.Messages.map(function (m) {
          return _jsx("li", {
            children: _jsx(CompactCompositeMessageItemWrapper, {
              item: m
            }, void 0)
          }, m.MsgId);
        })]
      }, void 0);
      break;

    default:
      assertNever(item.Type, "I do not support item.Type" + item.Type);
  }

  assert(info, "info falsy");
  var t = info.Timestamp.toString();
  var date = t.substring(0, _indexOf(t, "T"));
  var time = t.substring(_indexOf(t, "T") + 1, t.length - 1);
  var timestamp = date + " " + time;
  var avatarUrl = formatImageUrl(info.UserAvatar, ImageSizeTypeEnum.Thumbnail44whFill);
  return _jsxs("div", __assign({
    className: "chat-record"
  }, {
    children: [_jsx("img", {
      src: avatarUrl,
      className: "chat-record__avatar"
    }, void 0), _jsxs("div", __assign({
      className: "chat-record__info"
    }, {
      children: [_jsxs("span", __assign({
        className: "chat-record__username"
      }, {
        children: [info.UserName, " "]
      }), void 0), _jsxs("span", __assign({
        className: "chat-record__timestamp"
      }, {
        children: [" ", timestamp]
      }), void 0)]
    }), void 0), _jsx("div", __assign({
      className: "chat-record__inner"
    }, {
      children: inner
    }), void 0)]
  }), void 0);
}

var ChatRecordModal =
/** @class */
function (_super) {
  __extends(ChatRecordModal, _super);

  function ChatRecordModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      showModal: true
    };

    _this.handleCloseModal = function () {
      _this.setState({
        showModal: false
      });

      _this.props.onModalClose();
    };

    return _this;
  }

  ChatRecordModal.prototype.componentDidMount = function () {
    var delay = wait(10);
    delay["finally"](function () {
      var $modal = $(".chat-record-modal");
      var $modalCloseBtn = $(".chat-record-modal-close-btn");
      $modalCloseBtn.css("top", ($("body").get(0).clientHeight - $modal.get(0).clientHeight + 40) / 2 + "px");
      $modalCloseBtn.css("display", "block");
    });
  };

  ChatRecordModal.prototype.render = function () {
    var message = this.props.message;
    assert(message, "message falsy");
    var forwardAttrs = message.customAttrs;
    assert(forwardAttrs, "forwardAttrs fasly");
    var msgList = forwardAttrs.Messages;
    assert(msgList, "msgList falsy");
    assert(msgList.length > 0, "empty msg list!");
    return _jsx("div", {
      children: _jsxs(ReactModal, __assign({
        isOpen: this.state.showModal,
        contentLabel: "\u804A\u5929\u8BB0\u5F55",
        className: "chat-record-modal",
        overlayClassName: "chat-record-overlay",
        ariaHideApp: false,
        shouldCloseOnEsc: true,
        onRequestClose: this.handleCloseModal,
        shouldFocusAfterRender: true,
        shouldCloseOnOverlayClick: true
      }, {
        children: [_jsx("span", {
          onClick: this.handleCloseModal,
          className: "chat-record-modal-close-btn"
        }, void 0), _jsx("ul", __assign({
          className: "chat-record-list"
        }, {
          children: msgList.map(function (m) {
            return _jsx("li", __assign({
              className: "chat-record-list__item"
            }, {
              children: _jsx(CompactCompositeMessageItemWrapper, {
                item: m
              }, void 0)
            }), m.MsgId);
          })
        }), void 0)]
      }), void 0)
    }, void 0);
  };

  return ChatRecordModal;
}(React.Component);

export function showChatRecordModal(message) {
  var root = document.createElement("div");
  document.body.appendChild(root);

  var onModalClose = function onModalClose() {
    ReactDOM.unmountComponentAtNode(root);
    document.body.removeChild(root);
  };

  ReactDOM.render(_jsx(ChatRecordModal, {
    message: message,
    onModalClose: onModalClose
  }, void 0), root);
}